import React, { useState} from "react";
import "../Css/servicios.css";
import { FaUserGraduate, FaUniversity, FaStethoscope, FaWhatsapp, FaCheck} from "react-icons/fa";
import logoWhatsapp from "../Images/logo-whatsapp1.png";

// Datos de servicios - todos con el mismo color
const services = [
  {
    id: 1,
    title: "Título Profesional",
    description:
      "Te ayudamos a obtener tu título profesional con asesoría especializada en tu proyecto de investigación.",
    icon: FaUserGraduate,
    features: [
      "Asesoría personalizada.",
      "Elección y delimitación del tema.",
      "Redacción de artículo científico.",
      "Preparación constante hasta la entrega final.",
      "Garantía hasta terminar tu proyecto.",
    ],
    color: "#004e8e"
  },
  {
    id: 2,
    title: "Maestría",
    description:
      "Brindamos apoyo en la elaboración de tesis y proyectos de investigación para maestrías.",
    icon: FaUniversity,
    features: [
      "Asesoría personalizada.",
      "Corrección de estilo.",
      "Redacción académica de alto nivel.",
      "Preparación constante hasta la entrega final.",
      "Garantía hasta terminar tu proyecto.",
    ],
    color: "#004e8e" // Mismo color que Título Profesional
  },
  {
    id: 3,
    title: "Segunda Especialidad",
    description:
      "Brindamos orientación experta en la formulación, desarrollo y entrega de proyectos de segunda especialidad.",
    icon: FaStethoscope,
    features: [
      "Asesoría personalizada.",
      "Redacción científica.",
      "Preparación constante hasta la entrega final.",
      "Consultoría especializada.",
      "Garantía hasta terminar tu proyecto.",
    ],
    color: "#004e8e" // Mismo color que Título Profesional
  },
];

// Componente para cada servicio
const ServiceBox = ({ title, description, icon: Icon, features, color }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <div 
      className="s-box" 
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        borderTop: `4px solid ${color}`,
        transform: isHovered ? 'translateY(-10px)' : 'none'
      }}
    >
      <div className="service-icon" style={{ backgroundColor: color }}>
        <Icon />
      </div>
      <h1>{title}</h1>
      <div className="title-divider" style={{ backgroundColor: color }} />
      <p>{description}</p>
      <div className="additional-info">
        <h3>Características del servicio:</h3>
        <ul>
          {features.map((feature, index) => (
            <li key={index}>
              <span className="check-icon" style={{ color }}>
                <FaCheck />
              </span> 
              {feature}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

// Componente principal
const ServicesSection = () => {

  return (
    <section className="services bg-blanco">
      <div className="services-background"></div>
      <div className="s-heading">
        <h1>Nuestros Servicios</h1>
        <p className="service-subtitle">
          Asesoría académica especializada para alcanzar tus metas profesionales
        </p>
      </div>
      
      <div className="s-box-container">
        {services.map((service) => (
          <ServiceBox
            key={service.id}
            title={service.title}
            description={service.description}
            icon={service.icon}
            features={service.features}
            color={service.color}
          />
        ))}
      </div>
      
      <div className="cta-section-compact">
        <div className="cta-content">
          <h2>¿Tienes dudas? ¡Contáctanos!</h2>
          <a
            href="https://wa.me/51961867761"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-btn"
          >
            <FaWhatsapp className="whatsapp-icon" /> Escríbenos ahora
          </a>
        </div>
      </div>
      
      <a
        href="https://wa.me/51961867761"
        target="_blank"
        rel="noopener noreferrer"
        className="btn-circle whatsapp-btn-inicio"
      >
        <img
          src={logoWhatsapp}
          alt="WhatsApp"
          className="whatsapp-icon-inicio"
        />
      </a>
    </section>
  );
};

export default ServicesSection;